// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup_Q6qzu","hidden":"styles_hidden_sYFyy"};